import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const FounderTeaser = () => (
  <section data-testid="founder-teaser" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <div className="bg-[#E5DFD5] rounded-3xl px-6 md:px-14 py-16 md:py-24">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-6">
            02 / Founder
          </p>
          <p
            data-testid="founder-pullquote"
            className="font-display text-3xl md:text-5xl tracking-tighter leading-[1.1] text-[#2C241E]"
          >
            "I kept watching people abandon support that worked — because it looked like a
            setback."
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-6 text-xs font-medium tracking-[0.2em] uppercase text-[#2C241E]/50">
            Dr Shivam Jhatta PT — Founder, Melbourne
          </p>
          <Link
            to="/founder"
            data-testid="founder-teaser-link"
            className="mt-8 inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
          >
            Meet the founder
            <ArrowRight size={16} strokeWidth={1.75} />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
